import { useMutation, useQueryClient } from '@tanstack/react-query';
import { allergensUpdate } from '../../../store/Dish/api';

export const useUpdateDishAllergen = ({ refetch: refetchDish }) => {
    return useMutation(["updateDishAllergen"], ({ dish }) => allergensUpdate(dish), {
        onSuccess: async () => {
            if(refetchDish) {
                refetchDish()
            }
        },
    });
}
